import { ProductsDataTabMessages } from "@/messages/campaigns/poducts-data-tab.messages";

export const ITEMS_TABLE_COLUMNS = (messages: ProductsDataTabMessages) => {
  return [
    messages.productCodeLabel,
    messages.productNameLabel,
    messages.productDescriptionLabel,
    messages.productQuantityLabel,
    messages.stockColumnLabel,
    messages.promotionalPriceLabel,
    messages.optionsColumn,
  ];
};
